namespace advisorop.components.dashboardwidgets {
    
    export class InvHouseholdListController{

        showChangeColumn ;
        filterRow ;
        searchPanel ;
        investorHouseholds;
        investorId;
        refreshGrid;
        households;
        dgHouseholdsSettings: DevExpress.ui.dxDataGridOptions;
        onHouseholdChanged: (any) => any;

        static $inject = ["investorService", "generalService"];
        constructor(private invSrv: services.InvestorService, private gs: services.GeneralService) {
            
            this.dgHouseholdsSettings = {
                //export: {
                //    enabled: true,
                //    fileName: "HouseHolds"
                //},
                bindingOptions: {
                    dataSource: "vm.households",
                    "filterRow.visible": "vm.filterRow=='1'"
                    // "columns[4].visible": "vm.showChangeColumn == '1' && !vm.adminMode"                    
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: false,
                showRowLines: false,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "Household Not Found",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: this.searchPanel == "1",
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "name", caption: "Household Name", cellTemplate: "lnkName", visible: true },
                    { dataField: "advisoryFirmName", caption: "Advisory Firm", visible: true },
                    { dataField: "usdMarketValue", caption: "Market Value", format: "currency", visible: true },
                    { dataField: "id", caption: "Reports", cellTemplate: "btnAction", visible: true },
                ],
                selection: {
                    mode: "single",
                    showCheckBoxesMode: "onClick"
                },
                onSelectionChanged: function (selectedItems) {
                    var data = selectedItems.selectedRowsData[0];
                    if (data) {
                        this.vm.onHouseholdChanged({id: data.id});
                    }
                }
            };
            
        }

        loadHouseholds(): void {
            this.invSrv.getHouseholds(true)
                .then(data => this.households = data.data, err => this.gs.showError(err));
        };
        
        $onChanges(evt): void {
            for (var key in evt) {
                if (key == "refreshGrid") {
                    this.loadHouseholds();
                }
            }
        }

        $onInit(): void {
        }
        
    }
    
    class InvHouseholdList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                showChangeColumn: "@",
                filterRow: "@",
                searchPanel: "@",
                refreshGrid: "<",
                investorHouseholds: "@",
                onHouseholdChanged: "&"
            };
            this.controller = InvHouseholdListController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/investor-module/components/inv-household-list.html';
        }
    }
    angular.module(Constants.APP).component("invHouseholdList", new InvHouseholdList());

}